export const getOneSignalEnv = (): string | null => {
  return null;
  /* const domain = window.location.hostname;
  if (domain === "www.castelect.com") {
    return null; //`${process.env.REACT_APP_ONE_SIGNAL_APP_ID_PROD}`;
  } else if (domain === "development.castelect.com") {
    return `${process.env.REACT_APP_ONE_SIGNAL_APP_ID_DEV}`;
  } else if (domain === "localhost") {
    return null; //`${process.env.REACT_APP_ONE_SIGNAL_APP_ID_LOCAL}`;
  } else {
    return null;
  }*/
};

export const getGoogleApiKey = (): string | null => {
  const domain = window.location.hostname;
  if (domain === "www.castelect.com") {
    return `${process.env.REACT_APP_GOOGLE_CLIENT_ID_PROD}`;
  } else if (domain === "development.castelect.com") {
    return `${process.env.REACT_APP_GOOGLE_CLIENT_ID_DEV}`;
  } else if (domain === "localhost") {
    return `${process.env.REACT_APP_GOOGLE_CLIENT_ID_DEV}`;
  } else {
    return null;
  }
};
